import Tooltip from 'tooltip.js';
import { dataService } from './data_service';
import { tableService } from './table_service';

class ColumnFilterService {
  constructor() {
    this._defaultSelectedFilters = [
      'Product',
      'Product Group',
      'Type',
      'Insertion Tube  OD (mm)',
      'Distal End OD (mm)',
      'Channel ID (mm)',
      'Bending (Up/Down)',
      'Bending (Left/Right)',
      'Field of View',
      'Depth of Field (mm) (normal/wide)',
      'Depth of Field (mm) near/tele',
      'Water Jet',
    ];
    this._selectedFilters = this._defaultSelectedFilters.slice();
    this._tooltip = undefined;
  }

  get selectedFilters() {
    return this._selectedFilters;
  }

  get tableHeadersWithoutFrozen() {
    return dataService.headers.slice(tableService.frozenTableColumns);
  }

  setupTooltip() {
    this._tooltip = new Tooltip(
      document.getElementById('column-filters-trigger'),
      {
        title: document.getElementById('column-filters-tooltip').innerHTML,
        placement: 'bottom',
        trigger: 'manual',
        closeOnClickOutside: false,
        template:
          '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        html: true,
        popperOptions: {
          onCreate: () => {
            this.updateFilters();
          },
          onUpdate: () => {
            this.updateFilters();
          },
        },
      },
    );

    this.updateFiltersCount();
  }

  toggleTooltip() {
    this._tooltip.toggle();
  }

  updateFiltersCount() {
    $('span.counter.column-filters').text(
      this._selectedFilters.filter(Boolean).length,
    );
  }

  toggleFilter(filter) {
    let selected = filter.element.children[0].classList.toggle('selected');
    let value = filter.element.textContent;

    if (selected && !this._selectedFilters.includes()) {
      this._selectedFilters.push(value);
    } else {
      this._selectedFilters.splice(this._selectedFilters.indexOf(value), 1);
    }

    this.updateFiltersCount();

    if (this._selectedFilters.length >= dataService.headers.length) {
      $('.column-filters-tooltip .toggle-selection').addClass('inactive');
    } else {
      $('.column-filters-tooltip .toggle-selection').removeClass('inactive');
    }
  }

  updateFilters() {
    let html = '';
    let element = document.querySelector('.tooltip ul');

    for (let value of this.tableHeadersWithoutFrozen) {
      let selected = this._selectedFilters.includes(value);
      html += `<li data-controller="column-filter" data-action="click->column-filter#toggle">${value}<span class="icon ${
        selected ? 'selected' : ''
      }"></span></li>`;
    }

    element.innerHTML = html;

    this.updateFiltersCount();
  }

  clearAllSelectedFilters() {
    this._selectedFilters = this._defaultSelectedFilters.slice();
  }

  setAllFilters(target) {
    this._selectedFilters = dataService.headers;

    let items = document.querySelectorAll('.column-filters-tooltip li span');

    for (let item of items) {
      item.classList.add('selected');
    }

    target.classList.add('inactive');
  }

  close() {
    this._tooltip.hide();
  }

  applySelectedFiltersToData(data) {
    // First: Create a copy
    let result = {
      headerData: dataService.headers.slice(),
      bodyData: data.slice(),
    };

    // Iterate from right to left to keep correct indexes
    for (var i = result.headerData.length - 1; i >= 0; i--) {
      if (!this._selectedFilters.includes(result.headerData[i])) {
        result.headerData.splice(i, 1);

        for (var j = 0; j < result.bodyData.length; j++) {
          result.bodyData[j].splice(i, 1);
        }
      }
    }

    return result;
  }
}

export let columnFilterService = new ColumnFilterService();
